module.exports = __webpack_public_path__ + "img/PR8.53a08dce.png";